angular.module('env.data.services.auth', [])

    .run(function (authService) {
        if (authService.isAuthorized()) {
            authService.isTokenValid().then( // after page refresh
                function () { // session is still valid
                    authService.events.raise('continueSessionAfterReload');
                },
                function () { // session isn't valid anymore
                    authService.clearAuthentication();
                    authService.events.raise('authenticationRequiredAfterReload');
                });
        } else {
            authService.clearAuthentication();
            authService.events.raise('authenticationRequiredAfterReload');
        }
    })

    .provider('authService', function (EventingMixin) {
        var _this = this;

        _.extend(_this, new EventingMixin([
            'login',
            'loginFailed',
            'logout',
            'sessionExpired', // when session was expired
            'continueSessionAfterReload', // when the page was reloaded, but session is still active (and valid)
            'authenticationRequiredAfterReload' // when the page was reloaded, but old session is not active
        ]));

        var AUTH_TOKEN_STORAGE_NAME = "AuthToken";
        var USERNAME_STORAGE_NAME = "UserName";
        var FIRST_RUN_TOKEN = "FirstRun";

        this.$get = function ($log, $q, $timeout, $localStorage, $http, toastr, gettextCatalog, loginShadowService) {

            var _passwordValidationRegex;
            var _passwordValidationMessage;
            var _authToken;
            var _userName;
            var _lastUserName;
            var expirationTimeoutPromise;

            setToken($localStorage.getItem(AUTH_TOKEN_STORAGE_NAME));
            setUsername($localStorage.getItem(USERNAME_STORAGE_NAME));

            var _resetAuthInfo = function () {
                setToken(null);
                setUsername(null);
                if (expirationTimeoutPromise) {
                    $timeout.cancel(expirationTimeoutPromise);
                    expirationTimeoutPromise = null;
                }
            };

            /**
             * Set authorization token
             * @param token
             */
            function setToken(token) {
                _authToken = token ? _.clone(token) : null;
                if (_authToken) {
                    $localStorage.setItem(AUTH_TOKEN_STORAGE_NAME, _authToken);
                    // we use cookies only for file downloads
                    //$.cookie('Authorization', _authToken, {expires: 2, path: '/'});
                    $log.debug("Auth token is set to: " + _authToken);
                } else {
                    $localStorage.removeItem(AUTH_TOKEN_STORAGE_NAME);
                    //$.removeCookie('Authorization');
                    $log.debug("Auth token was dropped");
                }
                return token;
            }

            /**
             * Get authorization token
             * @returns {string} token
             */
            _this.getToken = function () {
                return _.clone(_authToken);
            };

            /**
             * For the very first run shows toastr with our cookie policy after login
             */
            _this.showCookiesPolicyMessage = function() {
                if ($localStorage.getItem(FIRST_RUN_TOKEN) === null) {
                    var cookiePolicyMessage = gettextCatalog.getString(
                        'AuthPopup.CookieStatement');
                    toastr.warning(cookiePolicyMessage, gettextCatalog.getString('OrderManager Cookie Policy'), { timeOut: 0, extendedTimeOut: 0 });
                    $localStorage.setItem(FIRST_RUN_TOKEN, _this.getUsername());
                }
            };

            /**
             * Get token info
             * @returns {Object} token info
             */
            _this.getTokenInfo = function () {
                if (_authToken) {
                    try {
                        var b64 = _authToken.split('.')[1];
                        b64 = b64.replace(/-/g, '+');
                        b64 = b64.replace(/_/g, '/');
                        return JSON.parse(atob(b64));
                    } catch (e) {

                    }
                }
                return null;
            };

            /**
             * Get current username
             * @returns {string} username of current user
             */
            _this.getUsername = function () {
                return _.clone(_userName);
            };

            /**
             * Get last used username. Used for re-login form.
             * @returns {string} username of user
             */
            _this.getLastUsername = function () {
                return _.clone(_lastUserName);
            };

            function setUsername(username) {
                _userName = username ? _.clone(username) : null;
                if (_userName) {
                    _lastUserName = _.clone(_userName);
                    $localStorage.setItem(USERNAME_STORAGE_NAME, _userName);
                } else {
                    $localStorage.removeItem(USERNAME_STORAGE_NAME);
                }

                return username;
            }

            /**
             * Resets first run flag in case a different user is logging in
             * @param {} username 
             * @returns {} 
             */
            function resetFirstRun(username) {
                if ($localStorage.getItem(FIRST_RUN_TOKEN) && $localStorage.getItem(FIRST_RUN_TOKEN) !== username) {
                    $localStorage.removeItem(FIRST_RUN_TOKEN, false);
                }
            }

            /**
             * Are we authorised
             */
            _this.isAuthorized = function () {
                return !!_authToken && new Date() < new Date(_this.getTokenInfo().exp);
            };

            /**
             * Check is token valid on the server. Request will be made only if token is active
             * @returns {Promise|HttpPromise} future object
             */
            _this.isTokenValid = function () {
                if (_authToken) {
                    return $http.get(om.config.build.baseUrl + "/users/current", {});
                } else {
                    var deferred = $q.defer();
                    deferred.reject("Not authorized. Auth token is undefined.");
                    return deferred.promise;
                }
            };

            /**
             * Authentication request
             * @param username - user name
             * @param pwd - user password(not a hash)
             * @returns {HttpPromise} Future object
             */
            _this.login = function (username, pwd) {
                var credentials = {
                    UserName: username,
                    Password: pwd
                };

                return $http
                    .post(om.config.build.baseUrl + "/auth/login", credentials)
                    .then(
                    function (resp) {
                        var t = resp.headers("Authorization");
                        _resetAuthInfo();
                        if (!t) {
                            _this.events.raise('loginFailed', {userName: username});
                            return $q.reject(resp);
                        }
                        setToken(t);
                        resetFirstRun(username);
                        setUsername(username);

                        expirationTimeoutPromise = $timeout(
                            function () {
                                _resetAuthInfo();
                                _this.events.raise('sessionExpired', {userName: username});
                            },
                            new Date(_this.getTokenInfo().exp) - new Date() - 60000);

                        _this.events.raise('login',
                            {
                                token: t,
                                userName: username
                            });
                        $log.trace("Logged in as " + username);
                        return resp;
                    },
                    function (resp) {
                        _resetAuthInfo();
                        _this.events.raise('loginFailed', {userName: username});
                        $log.trace("Login failed");
                        return $q.reject(resp);
                    });
            };

            /**
             * Logout request. In any request result(resolve or reject), authorization token will be dropped.
             * @returns {HttpPromise} Future object
             */
            _this.logout = function () {
                function afterLogout() {
                    _resetAuthInfo();
                    _this.events.raise('logout');
                    $log.trace("Logout!");
                }

                return $http.post(om.config.build.baseUrl + "/auth/logout", {})
                    .then(afterLogout, afterLogout);
            };

            /**
             * Clear all authentication and authorisation information (without posting 'logout' event)
             */
            _this.clearAuthentication = function () {
                _resetAuthInfo();
            };

            /**
             * Show reAuth window and wait till authorised
             */
            _this.reAuth = function () {
                var deferred = $q.defer();

                _resetAuthInfo();
                _this.events.on('login', function () {
                    if (deferred) {
                        deferred.resolve();
                    }
                });

                return $q.all([
                    loginShadowService.show(),
                    deferred.promise
                ]);
            };

            /**
             * Gets regular expression used by server side to validate new passwords according
             * to the policy applied on the server.
             * @returns {Promise|HttpPromise} future object
             */
            _this.getPasswordValidationRegex = function () {

                var deferred = $q.defer();
                if (_passwordValidationRegex) {
                    deferred.resolve(_passwordValidationRegex);
                } else {
                    _passwordValidationRegex = /.*/g; //default regex to allow any password
                    $http.get(om.config.build.baseUrl + "/passwordvalidation/regex", {})
                        .then(function (resp) {
                            try {
                                _passwordValidationRegex = resp.data;
                                deferred.resolve(_passwordValidationRegex);
                            } catch (err) {
                                deferred.reject(err);
                            }
                        }, function (err) {
                            deferred.reject(err);
                        });
                }

                return deferred.promise;
            };

            /**
             * Updates user's password with the new one.
             * @returns {Promise|HttpPromise} future object
             */
            _this.editPassword = function (oldPassword, newPassword) {

                return $http.post(om.config.build.baseUrl + '/users/changepassword', {
                    'oldPassword': oldPassword,
                    'newPassword': newPassword
                });
            };

            _this.requestPasswordReset = function (userNameOrEmail) {

                return $http
                    .post(om.config.build.baseUrl + '/passwordreset/request', { 'userNameOrEmail': userNameOrEmail })
                    .then(
                        function (resp) {
                            $log.trace("Requested password reset for [" + userNameOrEmail + "]");
                            return resp;
                        },
                        function (resp) {
                            $log.trace("Password reset request failed!");
                            return $q.reject(resp);
                        });

            };

            _this.doPasswordReset = function (resetRequestKey, newPassword) {

                return $http
                    .post(om.config.build.baseUrl + '/passwordreset/do', { 'resetRequestKey': resetRequestKey, 'newPassword': newPassword })
                    .then(
                        function (resp) {
                            $log.trace("Password has been reset for reset-request-key [" + resetRequestKey + "]");
                            return resp;
                        },
                        function (resp) {
                            $log.trace("Password reset failed for reset-request-key [" + resetRequestKey + "]!");
                            return $q.reject(resp);
                        });

            };

            return _this;
        };


    })

;